export const HOME_PATH = '/campaign-assistant';

/** Subscription states that mean the account already paid or has a charge in progress. */
export const BLOCKING_SUBSCRIPTION_STATUSES = ['active', 'past_due', 'pending_first_payment'];

export const primaryButtonClass =
    'w-full bg-gradient-to-r from-[#1F4068] to-[#1CB3B3] text-white py-3 px-6 rounded-lg font-medium hover:opacity-90 disabled:opacity-50 disabled:cursor-not-allowed transition-all duration-200 flex items-center justify-center gap-2 text-base shadow-lg hover:shadow-xl';
export const linkButtonClass = 'text-[#1CB3B3] hover:text-[#0D7377] font-medium disabled:opacity-50';
